module.exports = __webpack_public_path__ + "img/success-clipboard.f969f120.png";